<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
				
				<Row>
					<Col span="9">
						<FormItem label="名称" prop="name" class="" >
							<Input v-model="formValidate.name" placeholder="请输入名称" maxlength="32"></Input>
						</FormItem>
					</Col>
					<Col span="5">
					<FormItem label="一级分类"  prop="formValidate.type1"  class="">
						<Select  placeholder="请选择商品类别" v-model="formValidate.type1" @on-change="onchange1"  filterable>
							<Option v-for="item in operComTypes" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="5">
					<FormItem label="二级分类"  class="">
						<Select v-model="formValidate.type2"  @on-change="onchange2" placeholder="请选择商品类别" filterable>
							<Option v-for="item in operComTypes2" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="5">
					<FormItem label="三级分类" prop="operComType.id" class="">
						<Select v-model="formValidate.operComType.id" placeholder="请选择商品类别" filterable>
							<Option v-for="item in operComTypes3" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="5">
					<FormItem label="体积" prop="formValidate.volume" class="" >
						<Select  placeholder="选择体积" v-model="formValidate.volume">
							<Option v-for="item in volumes" :key="item.value" :value="item.value">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row >
					<Col span="24">
					<FormItem label="宣传短语" prop="title" class="">
						<Input v-model="formValidate.title" placeholder="请输入宣传短语" maxlength="64"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="12">
					<FormItem label="生产厂商" prop="operCommManuId" class="">
						<Select v-model="formValidate.operCommManuId" placeholder="请选择商家" filterable>
							<Option v-for="item in operCommManus" :key="item.id" :value="item.id">{{item.name}}-{{item.id}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="品牌" prop="operCommBrandId" class="">
						<Select v-model="formValidate.operCommBrandId" placeholder="请选择品牌" filterable>
							<Option v-for="item in operCommBrands" :key="item.id" :value="item.id">{{item.name}}-{{item.id}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="8">
						<FormItem label="进价" prop="purchasingPrice" class="">
							<Input v-model="formValidate.purchasingPrice" type="number" placeholder="请输入进价(单位:元)"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="售价" prop="sellPrice" class="">
							<Input v-model="formValidate.sellPrice" type="number" placeholder="请输入售价(单位:元)"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="单位" prop="unit" class="">
							<Input v-model="formValidate.unit" placeholder="请输入单位"></Input>
						</FormItem>
					</Col>
					
				</Row>
				
				<Row>
					<Col span="8">
					<FormItem label="商品规格" prop="specification" class="">
						<Input v-model="formValidate.specification" placeholder="请输入商品规格"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="商品条形码" prop="barCode" class="">
						<Input v-model="formValidate.barCode" placeholder="请输入商品条形码" ></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="存储条件"  class="">
						<Input v-model="formValidate.storage" placeholder="请输入存储条件"  maxlength="32"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="24" v-show="imgBool">
						<FormItem label="封面图" class="">
							<img style="width: 300px;" :src="formValidate.imgUrl" />
						</FormItem>
					</Col>
				</Row>
				<Row class=''  v-show="empType=='ADMIN'">
					<Col span="16">
						<FormItem label="上传图片"  class="">
							<Imgs @imgFile='imgFile' number='1' :url="url"/>
						</FormItem>
					</Col>
					
				</Row>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')"  v-show="empType=='ADMIN'">提交</Button>
					<!-- <Button @click="handleReset('formValidate')" style="margin-left: 8px"  v-show="empType=='ADMIN'">清空</Button> -->
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Imgs from '@/components/comm/imgs.vue'
	export default {
		data() {
			return {
				volumes:[
					{name:'1',value:'1'},
					{name:'2',value:'2'},
					{name:'3',value:'3'},
					{name:'4',value:'4'},
					{name:'5',value:'5'},
					],
				loading:false,
				empType:'',
				operType:'',
				operComTypes:[],
				operComTypes2:[],
				operComTypes3:[],
				operCommBrands:[],
				url:'',
				imgBool:true,
				formValidate: {
					/* name: '',
					operComType: {
						id:''
					},
					purchasingPrice: '',
					sellPrice: '',
					imgUrl:'https://img04.sogoucdn.com/net/a/04/link?url=http%3A%2F%2Fimg03.sogoucdn.com%2Fapp%2Fa%2F100520024%2F04257f36ea91cbcf2297c50b7342c836&appid=122',
					//imgs: [] */
				},
				ruleValidate: {
				
					barCode: [{
						required: true,
						message: '商品条形码不能为空！！！',
						trigger: 'blur'
					}],
					specification: [{
						required: true,
						message: '商品规格不能为空！！！',
						trigger: 'blur'
					}],
					operCommManuId: [{
						required: true,
						message: '生产厂商不能为空！！！',
						trigger: 'blur'
					}],
					operCommBrandId: [{
						required: true,
						message: '品牌不能为空！！！',
						trigger: 'blur'
					}],
					// actions: [{
					// 	required: true,
					// 	message: '主治功能不能为空！！！',
					// 	trigger: 'blur'
					// }],
					// norm: [{
					// 	required: true,
					// 	message: '国药准治号不能为空！！！',
					// 	trigger: 'blur'
					// }],
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					'operComType.id': [{
						required: true,
						message: '商品类别不能为空！！！',
						trigger: 'blur'
					}],
					purchasingPrice: [{
						required: true,
						message: '进价不能为空！！！',
						trigger: 'blur'
					}],
					sellPrice: [{
						required: true,
						message: '售价不能为空！！！',
						trigger: 'blur'
					}],
					img: [{
						required: true,
						message: '图片不能为空！！！',
						trigger: 'blur',
						type:'number'
					}],
					title: [{
						required: true,
						message: '宣传短语不能为空！！！',
						trigger: 'blur'
					}],
					
					unit: [{
						required: true,
						message: '单位不能为空！！！',
						trigger: 'blur'
					}],
					volume: [{
						required: true,
						message: '体积不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			onchange1(a){
				//查询商品类别
				let _this=this
				let query={
					page: 0,
					size: 1000,
					level:2,
					parentId:a
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper/all',
				    data: query,
					_this: _this,
					success: function(data) {
						_this.operComTypes2 = data.page.content
						if(_this.operComTypes2.length>0){
							_this.onchange2(_this.formValidate.type2)
						}
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			onchange2(a){
				//查询商品类别
				let _this=this
				let query={
					page: 0,
					size: 1000,
					level:2,
					parentId:a
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper/all',
				    data: query,
					_this: _this,
					success: function(data) {
						_this.operComTypes3 = data.page.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			handleSubmit(name) {
				let _this=this
				if(this.formValidate.img.length==0){
					this.$Message.error('请上传图片!');
					return ;
				}
				if (!(/(^[0-9]\d*$)/.test(_this.formValidate.barCode))) {
				
					this.$Message.error('请输入正确的条形码!');
					return;
				}
				_this.formValidate.unit=_this.formValidate.unit.trim()
				if(_this.formValidate.specification!=null){
					_this.formValidate.specification=_this.formValidate.specification.trim()
				}
				_this.formValidate.name=_this.formValidate.name.trim()
				_this.formValidate.title=_this.formValidate.title.trim()
				this.$refs[name].validate((valid) => {
					if (valid) {
						let aa={
							id:_this.formValidate.id,
							name: _this.formValidate.name,
							operComType: {
								id:_this.formValidate.operComType.id
							},
							purchasingPrice:Number((_this.formValidate.purchasingPrice*100).toFixed(2)),
							sellPrice:Number((_this.formValidate.sellPrice*100).toFixed(2)),
							img:_this.formValidate.img,
							unit:_this.formValidate.unit,
							title:_this.formValidate.title,
							volume:_this.formValidate.volume,
							actions:_this.formValidate.actions,
							norm:_this.formValidate.norm,
							operCommManuId:_this.formValidate.operCommManuId,
							operCommBrandId:_this.formValidate.operCommBrandId,
							specification:_this.formValidate.specification,
							barCode:_this.formValidate.barCode,
							storage:_this.formValidate.storage
						}
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/oper/operComMerchandise/update',
						    data: aa,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功！！！');
								
								_this.$emit('ajaxPage');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			imgFile(files){
				console.log(files) 
				this.formValidate.img=files.substr(0, files.length - 1);  
				if(this.formValidate.img.length>0){
					this.imgBool=false
				}else{
					this.imgBool=true
				}
			},
			ajaxPageBrand() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/comm/brand/query/oper',
					_this: _this,
					success: function(data) {
						_this.operCommBrands = data.operCommBrands
			
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			
			},
			
			ajaxPageManu() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/comm/manu/query/oper',
					_this: _this,
					success: function(data) {
						_this.operCommManus = data.operCommManus
			
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			
			}
			
		},
		components:{
			Imgs
		},
		created() {
			let _this=this
			this.empType = JSON.parse(sessionStorage.getItem("user")).empType
			_this.url=http.url+'/file/img/com'
			let id=this.$route.query.id
			if(id==undefined|| id==null || id==""){
				this.$Message.error('系统错误!');
				return ;
			}
			//查询商品类别
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/oper/operComType/page/oper/all',
			    data: {page:0,size:1000,parentId:0},
				_this: _this,
				success: function(data) {
					_this.operComTypes = data.page.content
					
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			//商品信息
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/oper/operComMerchandise/findById',
			    data:  {id:id},
				_this: _this,
				success: function(data) {
					_this.formValidate=data.data
					_this.formValidate.purchasingPrice=_this.formValidate.purchasingPrice/100+""
					_this.formValidate.sellPrice=_this.formValidate.sellPrice/100+""
					console.log(_this.formValidate)
					if(_this.formValidate.type1!=null){
						_this.onchange1(_this.formValidate.type1)
					}
					
					
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			  
			  _this.ajaxPageBrand()
			  _this.ajaxPageManu()
			
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		margin-left: 10%;
		width: 900px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}
	.ivu-row{
		margin-bottom: 20px;
	}

</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/comm/update.vue